import { initVideoModal } from "./components/video-modal.js";

initVideoModal();

const NAV_SELECTOR = "#navigation";
const HAMBURGER_SELECTOR = "#hamburger-menu";
const CLOSE_SELECTOR = "#close";

let state = {
  nav: null,
  hamburgerBtn: null,
  closeBtn: null,
  main: null,
  isOpen: false,
};

document.addEventListener("DOMContentLoaded", init);

function init() {
  state.nav = document.querySelector(NAV_SELECTOR);
  state.hamburgerBtn = document.querySelector(HAMBURGER_SELECTOR);
  state.closeBtn = document.querySelector(CLOSE_SELECTOR);
  state.main = document.querySelector("main");

  setupEventListeners();
}

function setupEventListeners() {
  state.hamburgerBtn?.addEventListener("click", openNav);
  state.closeBtn?.addEventListener("click", closeNav);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && state.isOpen) closeNav();
  });

  // Focus trap with Tab key
  state.nav?.addEventListener("keydown", handleFocusWrap);
}

function openNav() {
  state.isOpen = true;
  state.nav.classList.add("visible", "active");
  state.main?.setAttribute("aria-hidden", "true");

  // Sync accessibility state
  state.hamburgerBtn?.setAttribute("aria-expanded", "true");

  // Move focus instantly to the close button inside the menu
  requestAnimationFrame(() => {
    state.closeBtn?.focus();
  });
}

function closeNav() {
  state.isOpen = false;
  state.nav.classList.remove("active");
  state.main?.removeAttribute("aria-hidden");

  // Sync accessibility state
  state.hamburgerBtn?.setAttribute("aria-expanded", "false");

  requestAnimationFrame(() => {
    state.hamburgerBtn?.focus();
  });

  // Remove 'visible' after transition ends
  state.nav.addEventListener("transitionend", removeVisible, { once: true });
}

function removeVisible() {
  if (!state.isOpen) {
    state.nav.classList.remove("visible");
  }
}

function handleFocusWrap(e) {
  if (e.key !== "Tab") return;

  const focusable = getFocusableElements();
  if (focusable.length === 0) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
}

function getFocusableElements() {
  return Array.from(
    state.nav.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
  );
}